<!--
 * @Description: 车型识别一体机
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:52:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-24 17:01:14
 -->
<template>
  <div class="VehicleIdentification">
    <div class="left">
      <Left />
    </div>
    <div class="middle">
      <Middle />
    </div>
    <div class="right">
      <Right />
    </div>
  </div>
</template>

<script>
import Left from './components/left'
import Middle from './components/middle'
import Right from './components/right'
export default {
  name: 'VehicleIdentification',
  components: {
    Left,
    Middle,
    Right,
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .VehicleIdentification {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    >div {
      display: inline-block;
    }
    .left {
      width: 32%;
      height: 100%;
    }
    .middle {
      width: 36%;
      height: 100%;
    }
    .right {
      width: 32%;
      height: 100%;
    }
  }
</style>
